export default "__VITE_ASSET__729de16d__"